<template>
    <modal v-if="$root.showModal">
        <div 
            slot="header" 
            class="col-12">
            <h4 
                class="modal-title box-title" 
                style="line-height: 36px">
                Ustvari novega uporabnika
            </h4>
            <button 
                type="button" 
                class="close"
                aria-label="Zapri"
                @click.prevent="$root.closeModal">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div slot="body">
            <form 
                role="form" 
                @submit.prevent="addItem">
                <div class="box-body">
                    <div class="form-group">
                        <label for="name">Ime in priimek</label>
                        <input 
                            id="name"
                            v-model="newItem.name"
                            type="text"
                            class="form-control"
                            placeholder="Ime in priimek"
                            required>
                    </div>
                    <div class="form-group">
                        <label for="email">E-pošta</label>
                        <input 
                            id="email"
                            v-model="newItem.email"
                            type="email"
                            class="form-control"
                            placeholder="E-poštni naslov"
                            required>
                    </div>
                    <div class="form-group">
                        <label for="password">Geslo</label>
                        <input 
                            id="password"
                            v-model="newItem.password"
                            type="password"
                            class="form-control"
                            placeholder="Geslo"
                            pattern=".{6,}"
                            required>
                    </div>
                    <div class="form-group">
                        <label for="password_confirmation">Ponovi geslo</label>
                        <input 
                            id="password_confirmation"
                            v-model="newItem.passwordConfirmation"
                            type="password"
                            class="form-control"
                            placeholder="Ponovi geslo"
                            pattern=".{6,}"
                            required>
                    </div>
                    <div class="checkbox">
                        <label>
                            <input 
                                v-model="newItem.admin" 
                                type="checkbox">
                            <b>Skrbnik</b>
                        </label>
                    </div>
                </div>
                <div class="box-footer">
                    <button 
                        type="submit" 
                        class="btn btn-success">Shrani</button>
                </div>
            </form>
        </div>
    </modal>
</template>

<script>
import Modal   from './../Modal.vue';
import NewItem from '../../mixins/NewItem';

export default {
    name: 'NewUser',

    components: {
        Modal
    },

    mixins: [
        NewItem
    ],

    data() {
        return {
            newItem:    {
                email:                null,
                name:                 null,
                admin:                false,
                password:             null,
                passwordConfirmation: null
            }
        };
    },

    methods: {
        resetNewItem() {
            this.$set(this.newItem, 'email', null);
            this.$set(this.newItem, 'name', null);
            this.$set(this.newItem, 'admin', false);
            this.$set(this.newItem, 'password', null);
            this.$set(this.newItem, 'passwordConfirmation', null);
        },

        prepareNewItemData() {
            let data = (({email, name, admin}) => ({email, name, admin}))(this.newItem);

            if (!this.newItem.password || !this.newItem.passwordConfirmation) {
                this.$toast.error({
                    title:   'NAPAKA!',
                    message: 'Vnesite geslo!',
                    timeOut: 10000
                });

                return {};
            }

            if (this.newItem.password === this.newItem.passwordConfirmation) {
                data['password'] = this.newItem.password;
                data['password_confirm'] = this.newItem.passwordConfirmation;
            } else {
                this.$toast.error({
                    title:   'NAPAKA!',
                    message: 'Gesli se morata ujemati!',
                    timeOut: 10000
                });

                return {};
            }

            return data;
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Users/NewUser.vue